/**
 * CMCD parameter name.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_PARAM = 'CMCD';
//# sourceMappingURL=CMCD_PARAM.js.map